// React
import React from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  convertEventSelectToTarget,
  Currency,
  SelectInput,
} from '../../containers/componentsInjection';

export const SellersCommissionPage = ({
  validation,
  history,
  sellers,
  createData,
  organizations,
  handleOrganizationInputChange,
}) => {
  return (
    <PageWrapper title="Comissão de Corretores">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={6} className="mb-3">
                    <div>
                      <Label for="saleAtInput" className="form-label">
                        Período de venda
                      </Label>
                      <div className="d-flex justify-content-center align-items-center">
                        <Input
                          type="date"
                          id="periodStarts"
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          value={validation.values.periodStarts}
                          invalid={
                            !!(
                              validation.touched.periodStarts &&
                              validation.errors.periodStarts
                            )
                          }
                        />

                        <span className="m-2">a</span>

                        <Input
                          type="date"
                          id="periodEnds"
                          onBlur={validation.handleBlur}
                          onChange={validation.handleChange}
                          value={validation.values.periodEnds}
                          invalid={
                            !!(
                              validation.touched.periodEnds &&
                              validation.errors.periodEnds
                            )
                          }
                        />
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="sellerInput" className="form-label">
                        Corretor
                      </Label>
                      <SelectInput
                        isClearable
                        inputId="sellerInput"
                        value={validation.values.sellerInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );

                          if (!eventInput) {
                            validation.handleChange({
                              target: {
                                name: 'sellerInput',
                                value: {
                                  label: '',
                                  value: '',
                                },
                              },
                            });
                          }
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(sellers)}
                        placeholder="Todos"
                        invalid={
                          !!(
                            validation.touched.sellerInput &&
                            validation.errors.sellerInput
                          )
                        }
                      />
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3 ">
                      <Label htmlFor="comission" className="form-label">
                        Comissão
                      </Label>
                      <div className="input-group">
                        <Currency
                          config={{
                            locale: 'pt-BR',
                            formats: {
                              number: {
                                BRL: {
                                  currency: 'BRL',
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                },
                              },
                            },
                          }}
                          className="form-control form-control-suffix"
                          id="comission"
                          maxLength="6"
                          onChange={(_, valueWithoutMask) => {
                            validation.handleChange(
                              convertEventSelectToTarget(
                                'comission',
                                valueWithoutMask
                              )
                            );
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.comission || 0}
                        />
                        <span className="input-group-text" id="basic-addon2">
                          %
                        </span>
                      </div>

                      {validation.touched.comission &&
                      validation.errors.comission ? (
                        <p className="labelErrorValidation">
                          {validation.errors.comission}
                        </p>
                      ) : null}
                    </div>
                  </Col>

                  <Col md={6}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="organizationInput">
                        Exceto as organizações
                      </Label>
                      <SelectInput
                        multiple
                        inputId="organizationInput"
                        value={validation.values.organizationInput}
                        className="form-control"
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                          sessionStorage.setItem(
                            'organizationInput',
                            JSON.stringify(eventInput)
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'organizationInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(organizations)}
                        placeholder="Todas"
                      />
                    </div>
                  </Col>

                  <Col md={12}>
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="instructions">
                        Instruções
                      </Label>
                      <Input
                        id="instructions"
                        aria-multiline
                        type="textarea"
                        className="form-control"
                        onBlur={validation.handleBlur}
                        onChange={validation.handleChange}
                        value={validation.values.instructions}
                        style={{
                          height: 100,
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex btn-link justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{
                        marginRight: '10px',
                      }}
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
